module.exports = __webpack_public_path__ + "static/images/already-exchange.eb86fbe.png";